import React, { useEffect } from "react";
import LineChart from "Components/Charts/Line/Line";
import Block from "Components/UI/Block/Block";
import { useDashboard } from "./useDashboard";
import { useAppDispatch } from "Redux/store";
import { getDashboardInspectionSubmissionOutcomes } from "Redux/Dashboard/reducer";
import SkeletonLoader from "Components/SkeletonLoader/SkeletonLoader";
const InspectionSubmission: React.FC = () => {
  const { data, loading } = useDashboard();
  const dispatch = useAppDispatch();

  const numberOfDays = data.length || 0;

  const xAxisLabels = Array.from({ length: numberOfDays }, (_, i) =>
    (i + 1).toString()
  );

  useEffect(() => {
    dispatch(getDashboardInspectionSubmissionOutcomes());
  }, [dispatch]);

  if (loading) return <SkeletonLoader height="440px" />;

  return (
    <Block>
      <LineChart
        chartData={data}
        title="Inspection Submission"
        xAxisLabels={xAxisLabels}
      />
    </Block>
  );
};
export default InspectionSubmission;
